import { Component, Input } from '@angular/core';

@Component({
  selector: 'sketch-user-type',
  templateUrl: './user-type.component.html',
  styleUrls: ['./user-type.component.scss']
})
export class UserTypeComponent {
  @Input() type : string = '';
  decipheredClass: string = '';

  ngOnInit(){
    this.decipherClass(); 
  }
  ngOnChanges(){
    this.decipherClass(); 
  }

  decipherClass(){
    if( !this.type ){
      this.decipheredClass = '';
      return; 
    }
    if( this.type.toLowerCase() == 'tablet/warehouse'){
      this.decipheredClass = 'warehouse';
      return;
    }
    if( this.type.toLocaleLowerCase() == 'rep'){
      this.decipheredClass = 'half';
      return;
    }
    this.decipheredClass = this.type.toLowerCase();
  }
}
